import React, { useState, useEffect } from "react";
import Nav from "react-bootstrap/Nav";
import { Link, useLocation, useParams } from "react-router-dom";
import "../../../assets/css/cms/Products.css";
import loadable from "@loadable/component";
import Loading from "../../../components/utils/loader";
import PrivacyPolicy from "./privacyPolicy"
import TermsAndConditions from "./termsAndConditions"

function StaticPagesOverview(props) {
    const router = useLocation();
    const { param } = useParams();

    let relatedPath = router.pathname.split("/add-edit")[0];
    const [activeComponent, setActiveComponent] = useState();

    const STATIC_PAGES_ROUTES = [
        {
            path: "privacy-policy",
            exact: true,
            value: "",
            element: <PrivacyPolicy />,
        },
        {
            path: "terms-and-conditions",
            exact: true,
            value: "",
            element: <TermsAndConditions />,
        },
    ];

    useEffect(() => {
        if (param) {

            console.log("param: " + param);
            let activeComponent = STATIC_PAGES_ROUTES.find((obj) => {
                console.log("obj.path: " + obj.path);

                if (obj.path == param) {
                    console.log('obj', obj)
                    return obj;
                }
            })?.element;
            if (activeComponent) {
                setActiveComponent(activeComponent);
            } else {
                setActiveComponent(STATIC_PAGES_ROUTES[0].element);
            }
        } else {
            setActiveComponent(STATIC_PAGES_ROUTES[0].element);
        }
    }, [param]);

    return (
        <div>
            <div className={"nav_container"}>
                <Nav className={"sub_nav"}>
                    <Nav.Item
                        className={`${relatedPath == "/cms/static-pages" ||
                            router.pathname == "/cms/static-pages/privacy-policy/"
                            ? "nav_links_active"
                            : ""
                            }`}
                    >
                        <Nav.Link>
                            {" "}
                            <Link to="/cms/static-pages">Privacy Policy</Link>
                        </Nav.Link>
                    </Nav.Item>
                    <Nav.Item
                        className={`${relatedPath == "/cms/static-pages/terms-and-conditions" ||
                            router.pathname == "/cms/static-pages/terms-and-conditions"
                            ? "nav_links_active"
                            : ""
                            }`}
                    >
                        <Nav.Link>
                            {" "}
                            <Link to="/cms/static-pages/terms-and-conditions">Terms & Conditions</Link>
                        </Nav.Link>
                    </Nav.Item>
                </Nav>
            </div>
            {activeComponent}
        </div >
    );
}

export default StaticPagesOverview;
